import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React, { useContext } from 'react';

import { AttributeDefinitionsContext } from '../../AttributeDefinitionsContext';

function ReadOnlyFilter() {
  const { readOnly, setReadOnly } = useContext(AttributeDefinitionsContext);

  const handleChange = (e) => {
    const val = e.target.value === 'All' ? null : e.target.value;
    setReadOnly(val);
  };

  return (
    <FormControl fullWidth className="min-w-[140px]">
      <InputLabel id="read-only">Read Only</InputLabel>
      <Select
        labelId="read-only"
        label="Read Only"
        value={readOnly === null ? 'All' : readOnly}
        onChange={handleChange}
      >
        <MenuItem value="All">All</MenuItem>
        <MenuItem value>Yes</MenuItem>
        <MenuItem value={false}>No</MenuItem>
      </Select>
    </FormControl>
  );
}

export default ReadOnlyFilter;
